import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface AlertModel {
  serasaObj;
}

@Component({
  selector: 'app-crednet',
  templateUrl: './crednet.component.html',
  styleUrls: ['./crednet.component.scss']
})
export class CrednetComponent extends DialogComponent<AlertModel, boolean> implements AlertModel, OnInit {

  private pefinList;
  private refinList;
  private dividaList;
  private resumePefin;
  private resumeRefin;
  private resumeDivida;
  private resumeEstatual;
  serasaObj;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    console.log(this.serasaObj);
    if (this.serasaObj['PendenciasFinanceiras']) {
      this.pefinList = this.serasaObj['PendenciasFinanceiras'].filter(element => element.TipoAnotacao == 'V');
      this.resumePefin = this.serasaObj['CrednetResumos'].filter(element => element.Discriminacao == 'Pendências Financeiras Pefin');

      this.refinList = this.serasaObj['PendenciasFinanceiras'].filter(element => element.TipoAnotacao == 'I');
      this.resumeRefin = this.serasaObj['CrednetResumos'].filter(element => element.Discriminacao == 'Pendências Financeiras Refin');

      this.dividaList = this.serasaObj['PendenciasFinanceiras'].filter(element => element.TipoAnotacao == '5');
      this.resumeDivida = this.serasaObj['CrednetResumos'].filter(element => element.Discriminacao == 'Pendências Financeiras Dívida Vencida');
      this.resumeEstatual = this.serasaObj['CrednetResumos'].filter(element => element.Discriminacao == 'Protesto Estadual');
    }
  }

  closeModal() {
    this.close();
  }
}


// WEBPACK FOOTER //
// ./src/app/serasa/component/serasa/crednet/crednet.component.ts